<script setup lang="ts">
withDefaults(
  defineProps<{ as?: 'div' | 'a' | 'router-link'; padded?: boolean; clickable?: boolean }>(),
  { as: 'div', padded: true, clickable: false },
);
</script>

<template>
  <component
    :is="as"
    :class="['card', { 'card--padded': padded, 'card--clickable': clickable }]"
  >
    <slot />
  </component>
</template>

<style scoped>
.card {
  background: var(--bg-elevated);
  border-radius: var(--r-lg);
  border: 1px solid var(--hairline);
  transition: transform 0.12s ease, border-color 0.18s ease, background 0.18s ease;
}
.card--padded { padding: var(--sp-4); }
.card--clickable {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.card--clickable:hover { border-color: var(--accent-soft); }
.card--clickable:active { transform: scale(0.98); }
</style>
